import { Children, createElement, type ReactNode } from "react";

/**
 * Puts text children in a <span>, merging adjacent strings and numbers.
 * Page translation (Chrome's built-in translate) swaps bare text nodes for
 * <font> elements; when an icon or spinner beside the text then changes, React
 * inserts or removes next to a node that is gone and the page crashes. Text
 * React wrapped itself stays an element it owns.
 */
export function wrapText(children: ReactNode): ReactNode {
  const items = Children.toArray(children);
  if (
    !items.some((item) => typeof item === "string" || typeof item === "number")
  ) {
    return children;
  }
  const wrapped: ReactNode[] = [];
  let text = "";
  const flush = () => {
    if (text !== "") {
      wrapped.push(
        createElement("span", { key: `text-${wrapped.length}` }, text)
      );
      text = "";
    }
  };
  for (const item of items) {
    if (typeof item === "string" || typeof item === "number") {
      text += item;
    } else {
      flush();
      wrapped.push(item);
    }
  }
  flush();
  return wrapped;
}
